(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"]) return;
  try {
    
function loadRelatedProducts(root) {
  root.querySelectorAll('[data-related-products]').forEach(async (element) => {
    if (element.dataset.loaded) return;
    element.dataset.loaded = 'true';
    try {
      const response = await fetch(element.dataset.url);
      if (!response.ok) return;
      const document = new DOMParser().parseFromString(await response.text(), 'text/html');
      const replacement = document.querySelector('[data-related-products]');
      if (replacement && replacement.querySelector('article')) {
        element.innerHTML = replacement.innerHTML;
        element.hidden = false;
      }
    } catch {}
  });
}
loadRelatedProducts(document);
document.addEventListener('shopify:section:load', (event) => loadRelatedProducts(event.target));

  } catch(e) { console.error(e); }
})();
})();
